import { render, staticRenderFns } from "./MoreFileDetails.vue?vue&type=template&id=40c84513&"
import script from "./MoreFileDetails.vue?vue&type=script&lang=js&"
export * from "./MoreFileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports